const styles = (theme) => ({
  backgroundColor: "blue",
});

export default styles;
